'use client';

import { c as _c } from "react/compiler-runtime";
import { Banner } from '@/app/[locale]/(welcome)/auth/_components/Banner';
import SensitiveQueryParamsScrubber from '@/app/[locale]/(welcome)/auth/_components/SensitiveQueryParamsScrubber';
import { Root, LayoutWithBannerWrapper } from '@/app/[locale]/(welcome)/auth/_styled';
import { HideBelow } from '@/components/Media';
export default function LayoutWithBanner(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SensitiveQueryParamsScrubber />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HideBelow md={true}><Banner /></HideBelow>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <LayoutWithBannerWrapper>{t1}{t2}<Root>{children}</Root></LayoutWithBannerWrapper>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}